import { render } from "./AddressesList.vue?vue&type=template&id=34bb547c&scoped=true&ts=true"
import script from "./AddressesList.vue?vue&type=script&lang=ts"
export * from "./AddressesList.vue?vue&type=script&lang=ts"

import "./AddressesList.vue?vue&type=style&index=0&id=34bb547c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bb547c"]])

export default __exports__